import React from 'react';
import {useSelector} from 'react-redux';
import {MEMO_KEY_KOST} from 'module/Memo/util/MemoKey'
import {SlctFormat} from 'module/Slct/type/SlctType'
import {filterOptionsSlct} from 'module/Slct/util/filterOptionsSlct'
import {cssCFSlct} from 'module/CustomField/style/cssCFInput'
import {selKostSelectDataAll, selKostSelectDataOnlyVisible} from 'module/Kost/selector/KostSelectSelector'
import {KostSelectComponentProps} from 'module/Kost/type/KostSelectType'
import {Slct} from 'module/Slct/component/Slct'
import {selKostLoading} from 'module/Kost/selector/KostSelector'

export const KostkeySelectComponent = React.memo(function KostSelectComponent(
	props: KostSelectComponentProps
		& {
		displayFormat?: SlctFormat
		showClearButton?: boolean
	}) {
	const {kostkey, onChange, disabled, showClearButton, placeholderHTML, menuWidth, showOnlyVisible, memoSize, memoAutoAdd, displayFormat, align} = props
	const loading = useSelector(selKostLoading)
	let {options} = useSelector(showOnlyVisible ? selKostSelectDataOnlyVisible : selKostSelectDataAll)
	return <div className={'CustomFieldKostSelectComponent'} css={cssCFSlct}>
		<Slct
			loading={loading}
			value={kostkey}
			options={options}
			onChange={onChange}
			filterOptions={filterOptionsSlct}
			disabled={disabled}
			showClearButton={showClearButton}
			placeholderHTML={placeholderHTML}
			displayFormat={displayFormat || SlctFormat.Label}
			memo={{memoKey: MEMO_KEY_KOST, memoSize: memoSize || 0, memoAutoAdd: memoAutoAdd || false}}
			menuWidth={menuWidth}
			align={align}
		/>
	</div>
})